/* Bloom progressive enhancement. All store search, localization and add-to-cart forms work without JavaScript. No credit, payment, customer or inventory writes. */
(() => {
  if (window.hmBloomReady) return;
  window.hmBloomReady = true;
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openMenu = document.querySelector('.hmb-all-menu[open]');
    if (!openMenu) return;
    openMenu.removeAttribute('open');
    openMenu.querySelector('summary')?.focus();
  });
  document.addEventListener('click', (event) => {
    const openMenu = document.querySelector('.hmb-all-menu[open]');
    if (openMenu && event.target instanceof Node && !openMenu.contains(event.target)) openMenu.removeAttribute('open');
  });
  let headerObserver;
  const sizeHeader = () => {
    const header = document.querySelector('.hmb-header');
    if (!header || !document.body) return;
    const measure = () => {
      document.body.style.setProperty('--header-height', `${header.offsetHeight}px`);
      document.body.style.setProperty('--header-group-height', `${header.offsetHeight}px`);
      document.body.style.setProperty('--top-row-height', `${header.querySelector('.hmb-header__main')?.offsetHeight || 0}px`);
      document.body.style.setProperty('--transparent-header-offset-boolean', '0');
    };
    measure();
    headerObserver?.disconnect();
    if ('ResizeObserver' in window) { headerObserver = new ResizeObserver(measure); headerObserver.observe(header); }
  };
  sizeHeader();
  window.addEventListener('resize', sizeHeader, { passive: true });
  document.addEventListener('shopify:section:load', sizeHeader);
  let countTimer;
  const refreshCount = () => {
    clearTimeout(countTimer);
    countTimer = setTimeout(async () => {
      const nodes = document.querySelectorAll('[data-hmb-cart-count]');
      if (!nodes.length) return;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        if (!Number.isInteger(cart.item_count) || cart.item_count < 0) return;
        nodes.forEach(node => { const next = String(cart.item_count); if (node.textContent !== next) node.textContent = next; });
      } catch (_) { /* Keep the server-rendered count if the request fails. */ }
    }, 160);
  };
  window.addEventListener('pageshow', refreshCount);
  document.addEventListener('cart:update', refreshCount);
  document.addEventListener('cart:change', refreshCount);
  document.addEventListener('shopify:section:load', refreshCount);
})();
